import logo from "./logo.svg?url"

export default {
  src: logo,
  width: 172,
  height: 69,
}
